import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { OtpComponent } from './container/otp/otp.component';
import { PasscodeComponent } from './container/passcode/passcode.component';
import { MobileValidationComponent } from './container/mobile-validation-component/mobile-validation.component';
import { IdentificationCheckComponent } from './container/identification-check/identification-check.component';
import { MarketingOptionsComponent } from './container/marketing-options/marketing-options.component';
import { ForgotPasscodeComponent } from './container/forgot-passcode/forgot-passcode.component';
import { ForgotPasscodeOtpComponent } from './container/forgot-passcode-otp/forgot-passcode-otp.component';
import { SignupComponent } from './container/signup/signup.component';
import { GeneralLinkComponent } from './container/general-link/general-link.component';
import { MarketingResolver } from './resolvers/marketing.resolver';
import { RegulatoryResolver } from './resolvers/regulatory.resolver';
import { LandingComponent } from '../landing/landing.component';
import { SignInGuard } from '../../core/services/signin.guard';
import { MobileSubmitComponent } from './container/mobile-submit/mobile-submit.component';
import { VerifyEmailComponent } from './container/verify-email/verify-email.component';

const routes: Routes = [
  {
    path: '',
    children: [
      { path: '', component: LandingComponent, canActivate: [SignInGuard] },
      { path: 'sign-up', component: SignupComponent, canActivate: [SignInGuard] },
      { path: 'otp', component: OtpComponent },
      { path: 'passcode', component: PasscodeComponent },
      { path: 'mobile-validation', component: MobileValidationComponent },
      { path: 'identification-check', component: IdentificationCheckComponent },
      {
        path: 'marketing-options',
        component: MarketingOptionsComponent,
        resolve: {
          marketingResolver: MarketingResolver,
          regulatoryResolver: RegulatoryResolver
        }
      },
      { path: 'mobile-submit', component: MobileSubmitComponent },
      { path: 'forgot-passcode', component: ForgotPasscodeComponent },
      { path: 'forgot-passcode-otp', component: ForgotPasscodeOtpComponent },
      { path: 'sign-up', component: SignupComponent },
      { path: 'verify-email', component: VerifyEmailComponent },
      { path: 'general-link', component: GeneralLinkComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [MarketingResolver, RegulatoryResolver]
})
export class AuthRoutingModule {}
